module.exports = __webpack_public_path__ + "static/js/unsubscriptions.e58d0ae0.chunk.worker.js"